export default "__VITE_ASSET__CuJiKQOw__"